import React, { FC } from 'react'
import ReactMarkdown from 'react-markdown'
import S from './Step.styles'

interface StepProps {
  content: string
  icon: string
}

const Step: FC<StepProps> = ({ content, icon }) => {
  return (
    <S.Step>
      <div>
        <ReactMarkdown>{content}</ReactMarkdown>
      </div>
      <div>
        <img src={icon} alt="" />
      </div>
    </S.Step>
  )
}

export default Step
